export class BankAccount {
  constructor(
    public id: string,
    public iban: string,
    public clienteId: string,
  ) {  }
}
